import "./App.css";
import Router from "./infrastructure/router/Router";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SnackbarProvider } from "notistack";
import i18n from "./infrastructure/i18n/i18n";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/pt";
import "dayjs/locale/en";
import { observer } from "mobx-react-lite";
import UsersViewModel from "./viewmodels/UsersViewModel";
import React from "react";

const AppContent = observer(() => {
  const vmUsers = UsersViewModel.getInstance();
  const [isInitialized, setIsInitialized] = React.useState(false);
  
  React.useEffect(() => {
    // Initialize user from localStorage on app mount
    console.log('[App] Initializing user from localStorage');
    vmUsers.loadLocalStorageUser();
    setIsInitialized(true);
  }, [vmUsers]);
  
  if (!isInitialized) {
    return null; // Or a loading spinner if needed
  }
  
  const isLogged = !!(vmUsers.currentUser?.token && vmUsers.currentUser?.email);
  console.log('[App] User logged in:', isLogged, 'User:', vmUsers.currentUser);
  
  return (
    <SnackbarProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={String(i18n.language) ?? "es"}>
        <Router currentLang={"es"} logged={isLogged} />
      </LocalizationProvider>
    </SnackbarProvider>
  );
});

function App() {
  return <AppContent />;
}

export default App;
